// extracted by mini-css-extract-plugin
export default {"EPlogo":"ep-logo_EPlogo__TqRbU","EPimagesLogo":"ep-logo_EPimagesLogo__Qo3it","EPtextLogo":"ep-logo_EPtextLogo__6IleG","hidden":"ep-logo_hidden__cogdq"};